/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';

import {AuthenticationService} from './authentication.service';

/**
 * Authenticated router outlet that:
 * - checks current user permissions before activating next instruction and redirects to login view when necessary.
 * - ensures i18n translations are ready for authenticated users before activating any instruction
 */
export const AuthenticationGuard: CanActivateFn = (route, state) => {
  const authenticationService = inject(AuthenticationService);

  return authenticationService.isAuthenticated().then(authenticated => {
    if (!authenticated) {
      authenticationService.logout();
      return false;
    }
    return true;
  });
};
